import { useRemoveUSPModalStore } from "@forwardflow/store/modal/removeUSPModal";
import { Button } from "@forwardflow/ui";
import { Modal } from "antd";

export const RemoveUSPModal = ({ onDelete }: { onDelete: () => void }) => {
   const { isRemoveUSPModalOpen, closeRemoveUSPModal } =
      useRemoveUSPModalStore();
   return (
      <>
         <Modal
            className="ff-modal"
            title="Remove USP Permanently"
            open={isRemoveUSPModalOpen}
            onCancel={closeRemoveUSPModal}
            footer={null}
         >
            <p className="mt-5 mb-14">
               Are you sure you want to remove this Campaign Unique Selling
               Points ?
            </p>
            <Button
               onClick={() => (onDelete(), closeRemoveUSPModal())}
               className="w-full h-12 font-semibold transition-all border !rounded !bg-danger/20 hover:!bg-danger/50 !border-danger"
            >
               Remove USP
            </Button>
            <Button
               onClick={closeRemoveUSPModal}
               className="w-full h-12 mt-2 font-semibold transition-all border !rounded !bg-white/10 !border-white/20 hover:!bg-white/20"
            >
               Cancel
            </Button>
         </Modal>
      </>
   );
};
